module.exports = "<div [id]=\"'col_' + index + '_tta_' + filtros.tta\">\n    <ng-container #columnsContainer>\n\n    </ng-container>    \n</div>"